export const DEFAULT_NAME = 'seoOgImage';
export const DEFAULT_LABEL = 'Open Graph Image';

export const HELP_TOOLTIP_MESSAGE =
  'Upload an image that will appear when your content is shared on social media. For best results, use a clear image with a minimum size of 1200x630 pixels to ensure it looks great across platforms like Facebook and Twitter.';
